/* Crafty v5 — JS léger (aucune librairie). Chargé en defer après constants.js / pubsub.js / global.js.
   1 révélations au défilement · 2 compteur · 3 vidéo du héros + son · 4 vidéos de section + guide des lames
   5 « Added ✓ » sur le bouton d'achat · 6 ajout rapide (tiroir panier). Tout respecte prefers-reduced-motion. */
(function () {
  'use strict';
  var d = document, w = window;
  var mm = function (q) { return w.matchMedia ? w.matchMedia(q).matches : false; };
  var reduce = mm('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var hasIO = 'IntersectionObserver' in w;
  var idle = function (fn) { if (w.requestIdleCallback) { w.requestIdleCallback(fn, { timeout: 2500 }); } else { setTimeout(fn, 250); } };

  /* 1. Révélations : 600 ms, décalées (délai --cp-d posé dans le Liquid). Sans JS ou sans IO : tout reste visible. */
  var revealIO = null;
  function initReveal(root) {
    var els = root.querySelectorAll('[data-cp-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !hasIO) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      /* Dans un conteneur à défilement horizontal, l'IO ne se déclenche jamais pour les cartes hors écran : toujours visibles */
      if (el.closest && el.closest('.cp-choose__grid, .cp-gift__grid, .slider, [data-cp-noreveal]')) { el.classList.add('is-in'); return; }
      var r = el.getBoundingClientRect();
      if (r.top < w.innerHeight * 0.92 && r.bottom > 0) { el.classList.add('is-in'); } else { revealIO.observe(el); }
    });
  }

  /* 2. Compteur 0 → N, une seule fois */
  function initCount(root) {
    var els = root.querySelectorAll('[data-cp-count]:not([data-done])');
    if (!els.length) return;
    var run = function (el) {
      el.setAttribute('data-done', '1');
      var to = parseFloat(el.getAttribute('data-cp-count')) || 0;
      if (reduce || to <= 0) { el.textContent = to; return; }
      var t0 = null, dur = 1400;
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e);
        if (p < 1) w.requestAnimationFrame(step);
      };
      el.textContent = '0';
      w.requestAnimationFrame(step);
    };
    if (!hasIO) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 3. Héros : affiche d'abord (LCP), vidéo après load + temps libre, muette ; fondu 400 ms ; bouton son 🔈 */
  function initHero(root) {
    root.querySelectorAll('[data-cp-hero]').forEach(function (h) {
      if (h.getAttribute('data-ready')) return;
      h.setAttribute('data-ready', '1');
      var v = h.querySelector('video'), snd = h.querySelector('[data-cp-sound]'), play = h.querySelector('[data-cp-play]'),
        pz = h.querySelector('[data-cp-pause]'), userPaused = false; /* Ronde H (H2) : bouton pause */
      if (!v) return;
      var mobile = mm('(max-width: 749px)');
      var src = mobile ? (v.getAttribute('data-src-mobile') || v.getAttribute('data-src-desktop')) : (v.getAttribute('data-src-desktop') || v.getAttribute('data-src-mobile'));
      if (!src) return;
      var start = function () {
        if (!v.getAttribute('src')) { v.setAttribute('src', src); }
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { if (play) play.hidden = false; });
      };
      v.addEventListener('playing', function () {
        h.classList.add('is-playing');
        if (snd) snd.hidden = false;
        if (play) play.hidden = true;
        if (pz) pz.hidden = false; /* Ronde H (H2) */
      });
      /* Ronde H (H2, audit a11y n° 2, WCAG 2.2.2) : pause / lecture. La pause de la cliente est gardée (le retour à l'écran ne relance plus la vidéo) ;
         une relance (bouton pause, bouton son) remet l'état à jour. Retirer : supprimer ce bloc, pz / userPaused et « && !userPaused » plus bas. */
      var pzSync = function () {
        if (!pz) return;
        pz.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pz.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video');
      };
      v.addEventListener('play', function () { if (userPaused) { userPaused = false; pzSync(); } });
      if (pz) pz.addEventListener('click', function () {
        userPaused = !v.paused;
        if (userPaused) v.pause(); else v.play().catch(function () {});
        pzSync();
      });
      if (play) play.addEventListener('click', start);
      if (snd) {
        snd.addEventListener('click', function () {
          v.muted = !v.muted;
          if (!v.muted && v.paused) { v.play().catch(function () {}); }
          snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
          snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
          try { w.localStorage.setItem('cp-sound', v.muted ? '0' : '1'); } catch (e) {}
        });
      }
      /* Hors écran : pause (économie de batterie), reprise au retour */
      if (hasIO) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          if (!v.getAttribute('src')) return;
          if (e.isIntersecting) { if (v.paused && h.classList.contains('is-playing') && !userPaused) v.play().catch(function () {}); }
          else if (!v.paused) { v.pause(); }
        }, { threshold: 0.15 }).observe(h);
      }
      if (reduce || saveData) { if (play) play.hidden = false; return; }
      var later = function () { idle(start); };
      if (d.readyState === 'complete') later(); else w.addEventListener('load', later, { once: true });
    });
  }

  /* 4. Vidéos de section (chargées quand visibles) + guide des lames interactif (saut dans la vidéo) */
  function loadVideo(el) {
    if (!el.getAttribute('data-on')) {
      el.setAttribute('data-on', '1');
      el.querySelectorAll('source[data-src]').forEach(function (s) { s.src = (w.matchMedia && w.matchMedia('(max-width: 749px)').matches && s.getAttribute('data-src-mobile')) || s.getAttribute('data-src'); });
      el.load();
    }
  }
  function initLazyVideos(root) {
    var vids = root.querySelectorAll('video[data-cp-lazyvideo]:not([data-io])');
    if (!vids.length) return;
    /* Ronde G1 : l'affiche (data-poster) n'est posée qu'à ~1 200 px de la vidéo : elle ne dispute plus la bande passante à l'image LCP. */
    var setPoster = function (el) { var p = el.getAttribute('data-poster'); if (p && !el.getAttribute('poster')) el.setAttribute('poster', p); };
    /* Ronde H (H2, audit a11y n° 2, WCAG 2.2.2) : bouton pause / lecture posé sur la vidéo quand elle approche (rien au chargement initial).
       Une pause de la cliente (data-user-paused) est gardée au retour à l'écran ; un clic sur une lame relance (initBlades).
       Retirer : supprimer PZ, PL, addPause et remettre : var start = function (el) { setPoster(el); loadVideo(el); if (!reduce && !saveData) el.play().catch(function () {}); }; */
    var PZ = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>',
        PL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
    var addPause = function (el) {
      var box = el.parentNode; if (!box || box.querySelector('.cp-vpause')) return;
      var b = d.createElement('button'); b.type = 'button'; b.className = 'cp-vpause';
      var sync = function () { var p = el.paused; b.innerHTML = p ? PL : PZ; b.setAttribute('aria-label', p ? 'Play video' : 'Pause video'); };
      b.addEventListener('click', function () {
        if (el.paused) { el.removeAttribute('data-user-paused'); el.play().catch(function () {}); }
        else { el.setAttribute('data-user-paused', '1'); el.pause(); }
      });
      el.addEventListener('play', sync); el.addEventListener('pause', sync); sync();
      box.appendChild(b);
    };
    var start = function (el) { setPoster(el); loadVideo(el); addPause(el);
      if (!reduce && !saveData && !el.getAttribute('data-user-paused')) el.play().catch(function () {}); };
    if (!hasIO) { vids.forEach(start); return; }
    var pio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { setPoster(e.target); pio.unobserve(e.target); } });
    }, { rootMargin: '1200px 0px' });
    vids.forEach(function (el) { if (el.getAttribute('data-poster')) pio.observe(el); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { start(e.target); }
        else if (e.target.getAttribute('data-on')) { e.target.pause(); }
      });
    }, { rootMargin: '150px' });
    vids.forEach(function (el) { el.setAttribute('data-io', '1'); io.observe(el); });
  }
  function initBlades(root) {
    root.querySelectorAll('[data-cp-blades]').forEach(function (sec) {
      if (sec.getAttribute('data-ready')) return;
      sec.setAttribute('data-ready', '1');
      var v = sec.querySelector('video');
      var btns = Array.prototype.slice.call(sec.querySelectorAll('[data-seek]'));
      if (!btns.length) return;
      var marks = btns.map(function (b) { return parseFloat(b.getAttribute('data-seek')) || 0; });
      var mark = function (b) { btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); };
      var lock = 0;
      var go = function (b) {
        mark(b);
        if (!v) return;
        lock = Date.now();
        var t = parseFloat(b.getAttribute('data-seek')) || 0;
        loadVideo(v);
        var set = function () {
          try { v.currentTime = Math.min(t, (v.duration || t + 1) - 0.1); } catch (e) {}
          if (!reduce && !v.getAttribute('data-user-paused')) v.play().catch(function () {}); /* Ronde H (H2) : pause de la cliente respectée */
        };
        if (v.readyState >= 1) set(); else v.addEventListener('loadedmetadata', set, { once: true });
      };
      btns.forEach(function (b) {
        b.addEventListener('click', function () { if (v) v.removeAttribute('data-user-paused'); go(b); }); /* Ronde H (H2) : un clic sur une lame = « montre-moi » */
        b.addEventListener('focus', function () { go(b); });
        b.addEventListener('mouseenter', function () { if (mm('(hover: hover)')) go(b); });
      });
      /* Pendant la lecture, la lame du passage en cours s'allume */
      if (v) v.addEventListener('timeupdate', function () {
        if (Date.now() - lock < 800) return;
        var i, cur = 0;
        for (i = 0; i < marks.length; i++) { if (v.currentTime + 0.05 >= marks[i] && marks[i] >= marks[cur]) cur = i; }
        if (btns[cur].getAttribute('aria-pressed') !== 'true') mark(btns[cur]);
      });
    });
  }

  /* 5. « Added ✓ » sur le bouton d'achat (400 ms) + l'icône du panier pulse */
  var lastSubmit = null;
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && f.getAttribute('action') && f.getAttribute('action').indexOf('/cart/add') > -1) {
      lastSubmit = f.querySelector('[type="submit"]');
    }
  }, true);
  function added(btn) {
    var bubble = d.getElementById('cart-icon-bubble');
    if (bubble) { bubble.classList.remove('cp-pulse'); void bubble.offsetWidth; bubble.classList.add('cp-pulse'); }
    if (!btn) return;
    var span = btn.querySelector('span');
    if (!span) return;
    var label = span.textContent;
    btn.classList.add('cp-added');
    span.textContent = 'Added ✓';
    setTimeout(function () { btn.classList.remove('cp-added'); if (span.textContent === 'Added ✓') span.textContent = label; }, 1600);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'product-form' && !(ev.cartData && ev.cartData.status)) added(lastSubmit);
    });
  }

  /* 6. Ajout rapide (suggestions du tiroir, « Pairs well with », page /cart) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cp-quickadd]') : null;
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    var label = b.textContent;
    b.textContent = 'Adding…';
    var drawer = d.querySelector('cart-drawer');
    var onCartPage = w.routes && w.location.pathname === w.routes.cart_url;
    var body = { id: +b.getAttribute('data-cp-quickadd'), quantity: 1 };
    if (drawer && !onCartPage) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = w.location.pathname; }
    fetch(((w.routes && w.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.status) throw new Error('add');
      if (drawer && !onCartPage && res.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        added(null);
      } else {
        w.location.reload();
      }
    }).catch(function () { b.textContent = 'Try again'; b.removeAttribute('aria-busy'); setTimeout(function () { if (b.textContent === 'Try again') b.textContent = label; }, 2500); });
  });

  /* 6b. Échange en un clic dans le panier (PRO → Starter Set, Kit → Complete Kit) : data-cp-swap="lineKey|newVariantId" */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cp-swap]') : null;
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    var label = b.textContent, p = b.getAttribute('data-cp-swap').split('|');
    b.textContent = 'Upgrading…';
    var drawer = d.querySelector('cart-drawer');
    var onCartPage = w.routes && w.location.pathname === w.routes.cart_url;
    var hdr = { 'Content-Type': 'application/json', Accept: 'application/json' };
    /* 7A-5 (CRO 7h-02) : on AJOUTE d'abord le nouvel ensemble, puis on retire l'ancien article. Avant : retrait puis ajout → si l'ajout échouait, le PRO disparaissait du panier. */
    var add = { items: [{ id: +p[1], quantity: 1 }] };
    var chg = { id: p[0], quantity: 0 };
    if (drawer && !onCartPage) { chg.sections = 'cart-drawer,cart-icon-bubble'; chg.sections_url = w.location.pathname; }
    fetch(((w.routes && w.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: hdr, body: JSON.stringify(add) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(((w.routes && w.routes.cart_change_url) || '/cart/change') + '.js', { method: 'POST', headers: hdr, body: JSON.stringify(chg) }); })
      .then(function (r) { return r.json(); }).then(function (res) {
        if (!res || res.status) throw new Error('change');
        if (drawer && !onCartPage && res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); added(null); }
        else w.location.reload();
      }).catch(function () { w.location.reload(); });
  });

  /* 6c. Visiteuses venues de la vidéo d'Amy (YouTube, Linktree ou ?utm_source=amy) : une ligne d'accueil, pas de fenêtre 5 % */
  (function () {
    var ref = d.referrer || '', amy = false;
    try { amy = sessionStorage.getItem('cp_amy') === '1'; } catch (e) {}
    if (!amy && (/youtube\.com|youtu\.be|linktr\.ee/i.test(ref) || /[?&]utm_source=amy/i.test(w.location.search))) {
      amy = true; try { sessionStorage.setItem('cp_amy', '1'); } catch (e) {}
    }
    if (!amy) return;
    var pro = '/products/genuine-gyro-cut%C2%AE-pro-ultimate-craft-tool-with-rotating-standard-cut-paper-blade_b0c8w4q4jj_';
    var onPro = decodeURIComponent(w.location.pathname).indexOf('b0c8w4q4jj') > -1;
    /* Ch6 (6A-11) : plus de bandeau sur la fiche PRO (doublon de la ligne d'Amy, poussait la photo et le bouton de ~75 px) ; accueil seulement.
       Avant : if (w.location.pathname !== '/' && !onPro) return; */
    if (w.location.pathname !== '/') return;
    function show() {
      if (d.querySelector('.cp-amybar')) return;
      var bar = d.createElement('p'); bar.className = 'cp-amybar';
      /* Ronde D (D5) : le référent YouTube peut aussi être la chaîne du fabricant → « Coming from YouTube? » au lieu de « From Amy’s video? ». */
      bar.innerHTML = onPro ? '<span>Coming from YouTube? You’re in the right place: this is the Gyro-Cut PRO Amy Plans Things uses.</span>'
        : '<span>Coming from YouTube? This is the Gyro-Cut PRO that Amy Plans Things uses for her Dutch doors.</span> <a href="' + pro + '">See the PRO →</a>';
      var hdr = d.querySelector('.section-header') || d.querySelector('header');
      if (hdr && hdr.parentNode) hdr.parentNode.insertBefore(bar, hdr.nextSibling); else d.body.prepend(bar);
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', show); else show();
  })();

  /* 6d. Date de livraison estimée : expédié en 0–1 jour ouvrable + transit (É.-U. 4–7, Canada 2–5) → É.-U. +5 à +8, Canada +3 à +6 jours ouvrables */
  function initArrives(root) {
    root.querySelectorAll('[data-cp-arrives]').forEach(function (p) {
      var c = p.getAttribute('data-cp-arrives'), r = c === 'US' ? [5, 8] : c === 'CA' ? [3, 6] : null;
      if (!r) return;
      /* Ronde G2 (audit Noël n° 12) : même calcul que arrDate (un seul tableau de congés, plus de copie ici). */
      function add(n) { return arrDate(n, c); }
      var s = p.querySelector('span');
      if (s) s.innerHTML = 'Order today, arrives <b>' + add(r[0]) + ' – ' + add(r[1]) + '</b> <small>(estimate)</small>';
    });
    initArrivesShort(root);
  }
  /* Ronde A (R4) : version courte, dans la ligne sous le prix et dans le tiroir : seul [data-cp-when] change → « arrives Fri, Oct 30 – Wed, Nov 4 ».
       Mêmes délais et mêmes congés que ci-dessus. Marqué data-cp-done : jamais deux fois (le tiroir est observé, voir initDrawerArrives). */
  function initArrivesShort(root) {
    root.querySelectorAll('[data-cp-arrives-short]:not([data-cp-done])').forEach(function (p) {
      var c = p.getAttribute('data-cp-arrives-short'), r = c === 'US' ? [5, 8] : c === 'CA' ? [3, 6] : null;
      var s = p.querySelector('[data-cp-when]');
      p.setAttribute('data-cp-done', '1');
      if (!r || !s) return;
      s.innerHTML = '<span class="cp-when-d">arrives <b>' + arrDate(r[0], c) + ' – ' + arrDate(r[1], c) + '</b></span>';
    });
  }
  /* Ronde G2 (G2-2) : « aujourd'hui » des dates de livraison. Sur un thème d'essai avec une date simulée, le Liquid pose data-cp-sim="MMJJ" sur <html>
     (jamais sur le thème publié) → les dates partent de ce jour-là, comme le mode Noël rendu par le serveur. Sinon : la vraie date du navigateur. */
  function arrToday() {
    var t = new Date(); t.setHours(12, 0, 0, 0);
    var s = d.documentElement.getAttribute('data-cp-sim');
    if (s && /^\d{4}$/.test(s)) {
      var mo = +s.slice(0, 2) - 1, dy = +s.slice(2), x = new Date(t.getFullYear(), mo, dy, 12, 0, 0, 0);
      if (x.getMonth() === mo && x.getDate() === dy) {
        if (t - x > 183 * 864e5) x.setFullYear(x.getFullYear() + 1); /* ex. le 20 déc. avec une date simulée 0105 → 5 janv. suivant */
        t = x;
      }
    }
    return t;
  }
  function arrDate(n, c) {
    /* Ronde D (D5) : 11 nov. = Remembrance Day (Canada) ET Veterans Day (poste américaine fermée) → '*' (avant : 'CA'), ici et dans initArrives. */
    /* Ronde G2 (audit Noël n° 12) : SEUL tableau des congés du site (initArrives passe aussi par ici). À prolonger après le 15 févr. 2027. */
    var off = { '2026-11-11': '*', '2026-11-26': 'US', '2026-12-25': '*', '2026-12-28': 'CA', '2027-01-01': '*', '2027-01-18': 'US', '2027-02-15': 'US' };
    var t = arrToday();
    while (n > 0) {
      t.setDate(t.getDate() + 1);
      var k = t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2), h = off[k];
      if (t.getDay() === 0 || t.getDay() === 6 || h === '*' || h === c) continue;
      n--;
    }
    /* Ch6 (6A-6) : sans le jour de la semaine (« Oct 28 – Nov 2 ») → la ligne de livraison tient sur une ligne. Avant : weekday: 'short'. */
    return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  /* Ronde A (R4) : le tiroir est redessiné après chaque ajout (normal, rapide, échange, quantité) → refaire la date dedans */
  function initDrawerArrives() {
    var cd = d.querySelector('cart-drawer');
    if (!cd || cd.getAttribute('data-cp-mo') || !('MutationObserver' in w)) return;
    cd.setAttribute('data-cp-mo', '1');
    new MutationObserver(function () { initArrivesShort(cd); }).observe(cd, { childList: true, subtree: true });
  }

  /* Ronde A (R5) : pastille « ▶ Watch it cut · 10 s » sur la 1re photo de la galerie → montre la diapo vidéo et la lance (1 toque au lieu de 2 glissements + 1 toque).
     Repère posé par le Liquid (cp-product-extras, part watch). L'ordre de la galerie ne change pas. */
  function initWatchChip(root) {
    root.querySelectorAll('[data-cp-watch]').forEach(function (m) {
      var sec = m.closest('section') || d;
      var list = sec.querySelector('.product__media-list');
      if (!list || list.getAttribute('data-cp-chip')) return;
      var slide = list.querySelector('[data-media-id="' + m.getAttribute('data-cp-watch') + '"]');
      var first = list.querySelector('.product__media-item');
      if (!slide || !first || slide === first) return;
      list.setAttribute('data-cp-chip', '1');
      var b = d.createElement('button');
      b.type = 'button'; b.className = 'cp-watchchip';
      b.innerHTML = '<span aria-hidden="true">▶</span> ';
      /* Ronde H (H5, audit a11y n° 6) : nom lu « Watch it cut, 11-second video » (avant : « … · 11 s ») ; après le clic, le focus suit la vidéo
         (avant : il restait sur la pastille, sortie de l'écran avec la 1re photo). Retirer : remettre la ligne createTextNode d'origine, enlever aria-label et focusVid. */
      var lbl = m.getAttribute('data-label') || 'Watch it cut';
      b.appendChild(d.createTextNode(lbl));
      b.setAttribute('aria-label', lbl.replace(/ · (\d+) s$/, ', $1-second video'));
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var g = slide.closest('media-gallery');
        var focusVid = function () { var t = slide.querySelector('video, iframe, .deferred-media__poster'); if (t) { if (!t.hasAttribute('tabindex') && t.tagName !== 'BUTTON') t.setAttribute('tabindex', '-1'); try { t.focus({ preventScroll: true }); } catch (x) {} } };
        if (g && typeof g.setActiveMedia === 'function') { g.setActiveMedia(slide.getAttribute('data-media-id'), false); setTimeout(focusVid, reduce ? 50 : 500); return; }
        var poster = slide.querySelector('.deferred-media__poster');
        list.scrollTo({ left: slide.offsetLeft - first.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        if (poster) setTimeout(function () { poster.click(); }, reduce ? 0 : 450);
      });
      /* Ronde C (C1) : posée dans le cadre de l'image (.product-media-container), plus sur le li (qui déborde de la carte photo au cellulaire).
         Avant : first.classList.add('cp-has-chip'); first.appendChild(b); */
      var host = first.querySelector('.product-media-container') || first;
      host.classList.add('cp-has-chip');
      host.appendChild(b);
    });
  }

  /* Ronde B (B7) : aperçu hors saison de « un 2e pour offrir » (tiroir et /cart). ?cp_xmas=1 l'allume pour la visite (sessionStorage), ?cp_xmas=0 l'éteint.
     Montre les lignes servies cachées [data-cp-xmas] et garde 2 lignes au maximum (la dernière suggestion ordinaire est cachée, comme en saison).
     Sans le paramètre : ne fait rien (aucun observateur). */
  var xmasOn = null;
  /* Ronde C (C9) : la ligne à remplacer est marquée par le Liquid (data-cp-xmas-drop, la même qu'en saison) au lieu d'être devinée ici ;
     la classe cp-xmas sur <html> la cache aussi en CSS dès le rendu (tiroir redessiné avant l'observateur). */
  function xmasShow(root) {
    d.documentElement.classList.add('cp-xmas');
    root.querySelectorAll('[data-cp-xmas][hidden]').forEach(function (r) { r.hidden = false; });
    root.querySelectorAll('[data-cp-xmas-drop]').forEach(function (r) { r.hidden = true; });
  }
  function initXmasPreview(root) {
    if (xmasOn === null) {
      var m = /[?&]cp_xmas=([01])/.exec(w.location.search);
      xmasOn = !!(m && m[1] === '1');
      try {
        if (m) { if (m[1] === '1') sessionStorage.setItem('cp_xmas', '1'); else sessionStorage.removeItem('cp_xmas'); }
        xmasOn = sessionStorage.getItem('cp_xmas') === '1';
      } catch (e) {}
    }
    if (!xmasOn) return;
    xmasShow(root);
    var cd = d.querySelector('cart-drawer');
    if (cd && !cd.getAttribute('data-cp-xmo') && 'MutationObserver' in w) {
      cd.setAttribute('data-cp-xmo', '1');
      new MutationObserver(function () { xmasShow(cd); }).observe(cd, { childList: true, subtree: true });
    }
  }

  /* Ronde C (C4) : « Gyro-Cut » et « Extreme-Cut » ne se coupent plus au trait d'union en fin de ligne (« Gyro- / Cut »).
     Seulement dans le DOM affiché (titres, cartes, FAQ, boutons, menus) : le HTML servi (meta, JSON-LD, texte lu par Google) ne change pas.
     Aussi « 1 business day » et « 50 ml » insécables dans tous les textes visibles (jamais dans script / style). */
  var NB_SEL = 'h1,h2,h3,.card__heading,summary,button,.button,.cp-btn,.cp-link,.link,nav a,.list-menu a,.menu-drawer a,.footer-block a';
  var NB_SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1, OPTION: 1, SELECT: 1 };
  function nbWalk(el, fn) {
    var tw = d.createTreeWalker(el, 4 /* SHOW_TEXT */, null), list = [], t;
    while ((t = tw.nextNode())) { if (!NB_SKIP[t.parentNode.nodeName]) list.push(t); }
    list.forEach(fn);
  }
  function initNoBreak(root) {
    var re = /((?:Gyro|Extreme)-Cut®?)/;
    root.querySelectorAll(NB_SEL).forEach(function (el) {
      if (el.textContent.indexOf('-Cut') < 0) return;
      nbWalk(el, function (t) {
        if (!re.test(t.nodeValue) || !t.parentNode || (t.parentNode.closest && t.parentNode.closest('.cp-nb'))) return;
        var f = d.createDocumentFragment();
        t.nodeValue.split(re).forEach(function (p, i) {
          if (!p) return;
          if (i % 2) { var s = d.createElement('span'); s.className = 'cp-nb'; s.textContent = p; f.appendChild(s); } else f.appendChild(d.createTextNode(p));
        });
        /* Ronde D (D7) : TOUJOURS une seule enveloppe autour du texte remplacé. Avant, seulement si le parent était déjà en flex/grid au moment du test :
           si sa feuille de style arrivait après (pied de page, certaines FAQ), le parent devenait flex ensuite et « genuine / Gyro-Cut / ? » devenaient
           3 éléments flex écartés (« genuine   Gyro-Cut   ? ») ou l'espace était avalé (« ShopGyro-Cut »). Une span en ligne ne change rien ailleurs. */
        var o = d.createElement('span'); o.appendChild(f); f = o;
        t.parentNode.replaceChild(f, t);
      });
    });
    var body = root === d ? d.body : root;
    if (!body || (body.textContent.indexOf('business day') < 0 && body.textContent.indexOf('50 ml') < 0 && body.textContent.indexOf(' mm') < 0)) return;
    nbWalk(body, function (t) {
      var v = t.nodeValue, nv = v.replace(/\b1 business day/g, '1 business day').replace(/\b50 ml\b/g, '50 ml');
      nv = nv.replace(/(\d) mm\b/g, '$1 mm');
      if (nv !== v) t.nodeValue = nv;
    });
  }

  /* Ronde C (C8) : section « Drag to cut » (sections/cp-dragcut.liquid). Les 30 images du fabricant ne se chargent qu'à ~400 px de la section
     (au 1er geste si « économie de données ») ; elles sont dessinées sur un canevas depuis le cache (aucune requête pendant le glissement).
     Le curseur est un vrai input range (clavier, lecteur d'écran avec aria-valuetext). Mouvement réduit : pas de « coup de coude » de la poignée. */
  var DC_STEPS = [[1, 'Hold it like a pen'], [4, 'Guide it: the blade turns itself'], [20, 'Lift out a clean curve']];
  function initDragCut(root) {
    root.querySelectorAll('[data-cp-drag]:not([data-cp-done])').forEach(function (s) {
      s.setAttribute('data-cp-done', '1');
      var n = parseInt(s.getAttribute('data-frames'), 10) || 30, base = s.getAttribute('data-base'), ext = s.getAttribute('data-ext') || '.webp';
      var r = s.querySelector('[data-cp-drag-range]'), img = s.querySelector('[data-cp-drag-img]'), tag = s.querySelector('[data-cp-drag-step]');
      if (!r || !img || !base) return;
      var cache = [], loaded = false, cv = null, ctx = null, cur = 1;
      function pad(i) { return (i < 10 ? '0' : '') + i; }
      function load() {
        if (loaded) return; loaded = true;
        for (var i = 1; i <= n; i++) { var im = new Image(); im.decoding = 'async'; im.src = base + pad(i) + ext; cache[i] = im; }
      }
      function draw(im) {
        if (!im || !im.complete || !im.naturalWidth) return false;
        if (!cv) {
          cv = d.createElement('canvas'); cv.className = 'cp-drag__cv'; cv.setAttribute('aria-hidden', 'true');
          img.parentNode.insertBefore(cv, img.nextSibling);
          try { ctx = cv.getContext('2d'); } catch (e) { ctx = null; }
        }
        if (!ctx) { img.removeAttribute('srcset'); img.src = im.src; return true; }
        var k = Math.min(2, w.devicePixelRatio || 1), cw = Math.round(cv.clientWidth * k), ch = Math.round(cv.clientHeight * k);
        if (!cw || !ch) return false;
        if (cv.width !== cw || cv.height !== ch) { cv.width = cw; cv.height = ch; }
        var sc = Math.max(cw / im.naturalWidth, ch / im.naturalHeight), iw = im.naturalWidth * sc, ih = im.naturalHeight * sc;
        ctx.drawImage(im, (cw - iw) / 2, (ch - ih) / 2, iw, ih);
        return true;
      }
      function show(v) {
        cur = v;
        var st = 0;
        DC_STEPS.forEach(function (x, i) { if (v >= x[0]) st = i; });
        if (tag) tag.innerHTML = '<b>' + (st + 1) + '</b>' + DC_STEPS[st][1];
        r.setAttribute('aria-valuetext', 'Step ' + (st + 1) + ' of 3: ' + DC_STEPS[st][1]);
        r.style.setProperty('--p', ((v - 1) / (n - 1) * 100) + '%');
        var im = cache[v];
        if (im && !draw(im)) im.onload = function () { if (cur === v) draw(im); };
      }
      if (hasIO) {
        if (!saveData) {
          var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '400px 0px' });
          io.observe(s);
        }
        if (!reduce) {
          var ih = new IntersectionObserver(function (e) {
            if (e[0].isIntersecting) { if (!s.classList.contains('is-used')) s.classList.add('is-hint'); ih.disconnect(); }
          }, { threshold: 0.6 });
          ih.observe(r);
        }
      } else if (!saveData) load();
      r.addEventListener('input', function () { load(); s.classList.remove('is-hint'); s.classList.add('is-used'); show(parseInt(r.value, 10) || 1); });
      /* Ronde H (H5, audit a11y n° 5, WCAG 2.5.7) : Hold / Guide / Lift out sautent à l'étape (sans glisser). Retirer : supprimer ce bloc. */
      s.querySelectorAll('[data-cp-drag-go]').forEach(function (b) {
        b.addEventListener('click', function () {
          load(); r.value = b.getAttribute('data-cp-drag-go');
          s.classList.remove('is-hint'); s.classList.add('is-used'); show(parseInt(r.value, 10) || 1);
        });
      });
      var rq = 0;
      w.addEventListener('resize', function () {
        if (!cv || rq) return;
        rq = w.requestAnimationFrame(function () { rq = 0; draw(cache[cur]); });
      });
      show(parseInt(r.value, 10) || 1);
    });
  }

  /* Ronde I (I1) — « Take a closer look » (sections/cp-closer.liquid) : 3 gros plans qui jouent UNE fois, puis « Replay ».
     Vidéo chargée seulement à ~300 px de sa carte (data-src → src, comme initLazyVideos) ; au carrousel du cellulaire, la carte suivante
     se charge quand la précédente commence à jouer. Lecture à 60 % visible ; hors écran = pause (reprise au retour si pas finie, comme ronde H).
     Mouvement réduit ou économie de données : rien ne se charge ni ne joue seul, bouton « Play ». Retirer : supprimer ce bloc et son appel dans init. */
  var CC_RP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5V2L7 6l5 4V7a5 5 0 1 1-5 5H5a7 7 0 1 0 7-7z" fill="currentColor"/></svg>',
      CC_PL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
  function initCloser(root) {
    root.querySelectorAll('[data-cp-closer]:not([data-cp-done])').forEach(function (s) {
      s.setAttribute('data-cp-done', '1');
      var auto = !reduce && !saveData && hasIO, cards = [];
      s.querySelectorAll('[data-cp-closer-card]').forEach(function (c) {
        var v = c.querySelector('video'), b = c.querySelector('[data-cp-closer-btn]');
        if (!v || !b) return;
        var cap = b.getAttribute('data-cap') || '';
        var o = { c: c, v: v };
        o.load = function () {
          if (v.getAttribute('data-on')) return;
          v.setAttribute('data-on', '1');
          var src = v.querySelector('source[data-src]');
          if (src) src.src = src.getAttribute('data-src');
          v.preload = 'auto'; v.load();
        };
        var setBtn = function (kind) {
          if (!kind) { b.hidden = true; return; }
          var word = kind === 'play' ? 'Play' : 'Replay';
          b.innerHTML = (kind === 'play' ? CC_PL : CC_RP) + '<span>' + word + '</span>';
          b.setAttribute('aria-label', word + ' video: ' + cap);
          b.hidden = false;
        };
        o.go = function () {
          o.load(); setBtn(null);
          var p = v.play();
          if (p && p.catch) p.catch(function () { if (v.paused) setBtn(v.getAttribute('data-done') ? 'replay' : 'play'); });
        };
        v.addEventListener('playing', function () {
          c.classList.add('is-on');
          var i = cards.indexOf(o);
          if (auto && cards[i + 1]) cards[i + 1].load();
        });
        v.addEventListener('pause', function () { if (!v.ended) setBtn('play'); });
        v.addEventListener('ended', function () { v.setAttribute('data-done', '1'); setBtn('replay'); });
        b.addEventListener('click', o.go);
        if (!auto) setBtn('play');
        cards.push(o);
      });
      if (!auto || !cards.length) return;
      var lio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target._cc.load(); lio.unobserve(e.target); } });
      }, { rootMargin: '300px 0px' });
      var pio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var o = e.target._cc;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) { if (!o.v.getAttribute('data-done') && o.v.paused) o.go(); }
          else if (!e.isIntersecting && !o.v.paused) o.v.pause();
        });
      }, { threshold: [0, 0.6] });
      cards.forEach(function (o) { o.c._cc = o; lio.observe(o.c); pio.observe(o.c); });
    });
  }

  /* 7. Comparateur au cellulaire : toujours démarrer à 0 (première carte entière) */
  function initCarousels(root) {
    root.querySelectorAll('.cp-choose__grid').forEach(function (g) { g.scrollLeft = 0; });
  }
  w.addEventListener('load', function () { initCarousels(d); });

  /* Ronde F (F11) : « Add to cart · $X » sur TOUTES les fiches (avant : seulement les fiches avec choix d'ensemble, PRO / Starter / Kit).
     Le prix est lu dans le bloc prix de la fiche (déjà affiché, même format) ; refait quand Dawn remet « Add to cart » après un changement de variante.
     Ne touche jamais un bouton qui dit autre chose (Sold out, Unavailable, ou déjà un prix posé par le choix d'ensemble). Le HTML servi ne change pas. */
  function btnPrice(btn) {
    var sp = btn.querySelector('span'), base = (w.variantStrings && w.variantStrings.addToCart) || 'Add to cart';
    if (!sp || btn.disabled || sp.textContent.trim() !== base) return;
    var sid = btn.id.replace('ProductSubmitButton-', ''), pw = d.querySelector('#price-' + sid + ' .price');
    if (!pw) return;
    var it = pw.classList.contains('price--on-sale') ? pw.querySelector('.price__sale .price-item--sale') : pw.querySelector('.price__regular .price-item--regular');
    var p = it && it.textContent.trim();
    if (!p || !/\d/.test(p)) return;
    sp.textContent = base + ' · ' + p;
    var st = d.getElementById('CpSticky-' + sid), sb = st && st.querySelector('.cp-sticky__t b');
    if (sb) sb.textContent = p;
  }
  function initBtnPrice(root) {
    root.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach(function (btn) {
      btnPrice(btn);
      if (btn.hasAttribute('data-cp-bp') || !w.MutationObserver) return;
      btn.setAttribute('data-cp-bp', '');
      new MutationObserver(function () { btnPrice(btn); }).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    });
  }

  /* Ronde F (F12) : fiche Sticky Mat — la ligne « 2 bottles · $48 total » sous les pastilles suit la taille choisie
     (lignes rendues par Shopify avec le vrai prix de chaque variante : on ne fait que montrer la bonne). */
  function initPackTotal(root) {
    root.querySelectorAll('[data-cp-packtotal]').forEach(function (pt) {
      if (pt.hasAttribute('data-cp-on')) return;
      pt.setAttribute('data-cp-on', '');
      var box = pt.closest('.product__info-container') || d;
      function upd() {
        var r = box.querySelector('variant-radios input:checked, variant-selects input:checked, variant-selects select');
        if (!r || !r.value) return;
        var spans = pt.querySelectorAll('[data-t]'), hit = null;
        spans.forEach(function (s) { if (s.getAttribute('data-t') === r.value) hit = s; });
        if (!hit) return;
        spans.forEach(function (s) { s.hidden = s !== hit; });
      }
      box.addEventListener('change', upd);
      upd();
    });
  }

  function init(root) {
    initCarousels(root);
    initReveal(root); initCount(root); initHero(root); initLazyVideos(root); initBlades(root); initArrives(root);
    initDrawerArrives(); /* Ronde A (R4) */
    initWatchChip(root); /* Ronde A (R5) */
    initXmasPreview(root); /* Ronde B (B7) */
    initNoBreak(root); /* Ronde C (C4) */
    initDragCut(root); /* Ronde C (C8) */
    initCloser(root); /* Ronde I (I1) */
    initBtnPrice(root); initPackTotal(root); /* Ronde F (F11, F12) */
  }
  d.documentElement.classList.add('cp-rv');
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  /* Éditeur de thème : réinitialiser la section rechargée */
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
